import React__default, { useEffect } from 'react';
import clsx from 'clsx';
import colors from '../../util/colors.js';
import { ContextualAlertButton } from '../ContextualAlertButton/ContextualAlertButton.component.js';
import { CloseTimer } from '../CloseTimer/CloseTimer.component.js';
import { Hyperlink } from '../Hyperlink/Hyperlink.component.js';
import SvgDangerSolidTriangle from '../Icon/icons/danger-solid-triangle.svg.js';
import SvgSuccessSolid from '../Icon/icons/success-solid.svg.js';
import { propTypes, defaultProps } from './Toast.types.js';
import './Toast.scss.js';
import styles from './Toast.module.scss.js';

var Toast = function (props) {
    var title = props.title, content = props.content, buttonText = props.buttonText, variant = props.variant, onClose = props.onClose, onClick = props.onClick, autoClose = props.autoClose, className = props.className, dataTestId = props["data-testid"];
    useEffect(function () {
        if (variant === 'informative' || variant === 'warning') {
            console.warn('DEPRECATION WARNING: The `informative` and `warning` variants are deprecated will be removed soon. Please use `success` and `danger` variants instead.');
        }
        if (!!title && (variant === 'success' || variant === 'danger')) {
            console.warn('DEPRECATION WARNING: The `title` prop was deprecated for `success` and `danger` variants. Please use `informative` and `warning` variants instead');
        }
    }, [variant]);
    var variantClass = styles['Toast___' + variant];
    var isLargeToast = Boolean(autoClose) && !!onClick;
    var isDeprecatedVariant = variant === 'informative' || variant === 'warning';
    var ToastIcon = function (props) {
        var variant = props.variant;
        if (variant === 'danger') {
            return React__default.createElement(SvgDangerSolidTriangle, { width: 24, height: 24 });
        }
        if (variant === 'success') {
            return React__default.createElement(SvgSuccessSolid, { width: 24, height: 24 });
        }
        return null;
    };
    return (React__default.createElement("div", { className: clsx(styles.Toast, variantClass, isLargeToast && styles.Toast___large, className), "data-testid": dataTestId },
        isDeprecatedVariant && (React__default.createElement("div", { className: styles.Title },
            React__default.createElement("div", { className: styles.Title_content }, title),
            React__default.createElement("div", { className: styles.Title_closeButton }, onClose && autoClose && (React__default.createElement(CloseTimer, { color: colors.black, duration: autoClose, onClick: onClose, isToast: true }))))),
        React__default.createElement("div", { className: styles.Content, 
            // Notifications & toasts should have role='alert' for accessibility:
            // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_alert_role
            role: "alert" },
            React__default.createElement("div", { className: styles.Content_icon },
                React__default.createElement(ToastIcon, { variant: variant })),
            React__default.createElement("div", { className: styles.Content_text }, content)),
        React__default.createElement("div", { className: styles.CallToAction },
            onClick && buttonText && (React__default.createElement("div", { className: styles.ActionLink, tabIndex: 0 }, isDeprecatedVariant ? (React__default.createElement(ContextualAlertButton, { onClick: onClick, variant: variant || 'warning', name: buttonText, className: styles.AlertButton }, buttonText)) : (React__default.createElement(Hyperlink, { className: styles.ToastLink, onClick: onClick }, buttonText)))),
            onClose && autoClose && !isDeprecatedVariant && (React__default.createElement("div", { className: styles.Toast_closeButton, tabIndex: 0 },
                React__default.createElement(CloseTimer, { color: colors.black, duration: autoClose, onClick: onClose, isToast: true }))))));
};
Toast.displayName = 'Toast';
Toast.propTypes = propTypes;
Toast.defaultProps = defaultProps;

export { Toast, Toast as default };
